import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Insta360Section.module.css';

const PRICE_ROWS = [
  { durationKey: 'd1', price: '700 THB' },
  { durationKey: 'd2', price: '1300 THB' },
  { durationKey: 'd3', price: '1800 THB'},
  { durationKey: 'd5', price: '2800 THB' },
  { durationKey: 'd7', price: '3500 THB'},
  { durationKey: 'd10', price: '4500 THB' },
  { durationKey: 'd14', price: '5600 THB' },
];

function Insta360Section() {
  const { t } = useTranslation();

  return (
    <section id="insta360" className={styles.section}>
      <div className={styles.intro}>
        <h2 className={styles.heading}>{t('insta360.heading')}</h2>
        <p className={styles.subheading}>{t('insta360.subheading')}</p>
        <p className={styles.description}>{t('insta360.description')}</p>
      </div>

      <div className={styles.row}>
        <div className={styles.colImage}>
          <div className={styles.imageCard}>
            <img src="/insta360-x4.png" alt={t('insta360.heading')} loading="lazy" />
          </div>
        </div>

        <div className={styles.colContent}>
          <article className={styles.card}>
            <h3>{t('insta360.whyTitle')}</h3>
            <ul>
              {[1, 2, 3, 4].map((i) => (
                <li key={i}>
                  <span className={styles.check}>✓</span> {t(`insta360.why${i}`)}
                </li>
              ))}
            </ul>
          </article>

          <article className={styles.card}>
            <h3>{t('insta360.pricesTitle')}</h3>
            <p className={styles.popularLine}>{t('insta360.popularPriceLine')}</p>
            <div className={styles.priceRows}>
              {PRICE_ROWS.map((row) => (
                <div key={row.durationKey} className={styles.priceRow}>
                  <span>{t(`insta360.${row.durationKey}`)}</span>
                  <span className={styles.priceValue}>
                    {row.price}
                  </span>
                </div>
              ))}
            </div>
            <p className={styles.todayDiscount}>{t('insta360.todayDiscount')}</p>
          </article>

          <article className={styles.card}>
            <h3>{t('insta360.includedTitle')}</h3>
            <ul className={styles.includedGrid}>
              {[1, 2, 3, 4, 5].map((i) => (
                <li key={i}>✔ {t(`insta360.inc${i}`)}</li>
              ))}
            </ul>
          </article>

          <article className={styles.card}>
            <h3>{t('insta360.termsTitle')}</h3>
            <ul>
              {[1, 2, 3].map((i) => (
                <li key={i}>✔ {t(`insta360.term${i}`)}</li>
              ))}
            </ul>
            <a
              href="https://wa.me/66943672385"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.button}
            >
              {t('insta360.bookNow')}
            </a>
          </article>
        </div>
      </div>
    </section>
  );
}

export default Insta360Section;
